import React, { useMemo } from 'react';
import moment from 'moment';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import AgGridTable from 'components/AGGridTable/AgGridTable';

const FILE_TYPES = {
	unknown: 0,
	spendcubeByVendor: 1,
	spendcubeVendorTransactions: 2,
	unclassifiedSpendcube: 4,
};

const FILE_TYPES_TABLE_TEXT = {
	[FILE_TYPES.unknown]: '',
	[FILE_TYPES.spendcubeByVendor]: 'Spendcube by Vendor',
	[FILE_TYPES.spendcubeVendorTransactions]: 'Spendcube Vendor Transactions',
	[FILE_TYPES.unclassifiedSpendcube]: 'Unclassified Spendcube',
};

const getFormattedDate = date => {
	const formattedDate = moment(date, moment.ISO_8601);
	return formattedDate.format('MMMM Do, h:mm a');
};

export const FileArchiveTable = props => {
	const { data } = props;
	const gridStyle = useMemo(() => ({ height: '210px' }), []);
	const defaultColDef = useMemo(() => {
		return {
			flex: 1,
			minWidth: 100,
			resizable: true,
			sortable: true,
			filter: false,
		};
	}, []);

	const columnDefs = [
		{
			headerName: 'File Name',
			field: 'fileName',
		},
		{
			headerName: 'Type',
			field: 'type',
		},
		{ field: 'userName', headerName: 'Consultant Name' },
		{ field: 'date', headerName: 'Date' },
	];

	const rowData = useMemo(
		() => {
			if (data.length > 0) {
				return data.map(row => {
					return {
						...row,
						type:
							FILE_TYPES_TABLE_TEXT[
								(row.fileType && row.fileType.value) || FILE_TYPES.unknown
							],
						date: getFormattedDate(row.date),
					};
				});
			} else {
				return [];
			}
		},
		[data]
	);

	const gridOptions = {
		modules: AllModules,
		rowData,
		columnDefs,
		defaultColDef,
		pagination: true,
		paginationPageSize: 5,
	};

	return <AgGridTable gridOptions={gridOptions} gridStyle={gridStyle} />;
};
